import { LegalPageLayout } from "../components/LegalPageLayout.tsx";
import { termsDoc } from "../legalDocs.ts";
import legalTranslations from "../legalTranslations.json";

export const Terms = ({
  initialLang = "en",
}: {
  initialLang?: "en" | "he";
}) => (
  <LegalPageLayout
    docEn={termsDoc}
    docHe={legalTranslations.terms}
    initialLang={initialLang}
  />
);
